import React from 'react'


const Learn = () => (
	<div syle={{height:'600px',width:'888px'}}>
		<iframe src="learn.html" width="888px" height="9200px" frameBorder="0"></iframe>
	</div>
)

export default Learn


/** WEBPACK FOOTER **
 ** ./src/components/Learn.js
 **/